import CareLogo from "../../../assets/icons/Care32-02.png";

type CareCornerLogoProps = {
  /** `wall` = single-room / legacy full-bleed; `grid` = multi-room board with safe-area inset */
  variant: "wall" | "grid";
};

export function CareCornerLogo({ variant }: CareCornerLogoProps) {
  const className =
    variant === "grid"
      ? "pointer-events-none absolute bottom-[max(env(safe-area-inset-bottom,0px),clamp(12px,2vmin,28px))] right-[max(env(safe-area-inset-right,0px),clamp(12px,2.5vmin,36px))] z-[1] h-[clamp(64px,7.5vmin,100px)] w-auto max-w-[min(40vw,220px)] object-contain"
      : "pointer-events-none absolute bottom-[clamp(16px,2.5vmin,36px)] right-[clamp(16px,2.5vmin,36px)] h-[clamp(72px,9vmin,120px)] w-auto max-w-[min(28vmin,320px)] object-contain";

  return <img src={CareLogo} alt="" className={className} />;
}
